import { Component } from 'react'

import Notification from ':/_console/js/components/Notification.tsx'
import UsersApi from '~/api/UsersApi.ts'
import disableOnSpeRequest from '~/utils/disableOnSpeRequest.ts'
import type { SpeCreatorReturn } from '~/utils/SpeCreator'

interface Props {
  email: string
}

interface State {
  speVerifyEmailAddress: Partial<SpeCreatorReturn<object>>
}

class EmailNotVerifiedBanner extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      speVerifyEmailAddress: {},
    }
  }

  apiVerifyEmailAddress = () => {
    return UsersApi.verifyEmailAddress((spe) => this.setState({ speVerifyEmailAddress: spe }))
  }

  render = () => {
    const { email } = this.props
    const { speVerifyEmailAddress } = this.state

    if (speVerifyEmailAddress.status === 'success') {
      return (
        <Notification success small>
          We sent an email to {email}. Please click the link in that email to verify your email
          address.
        </Notification>
      )
    }

    if (
      speVerifyEmailAddress.status === 'failure' ||
      speVerifyEmailAddress.status === 'request' ||
      !speVerifyEmailAddress.status
    ) {
      return (
        <>
          <Notification small warning style={disableOnSpeRequest(speVerifyEmailAddress)}>
            You need to verify your email address in order to gain API access.
            <button
              type="button"
              className="btn btn--inline-link"
              onClick={this.apiVerifyEmailAddress}
            >
              Re-send verification email
            </button>
          </Notification>

          {speVerifyEmailAddress.status === 'failure' && (
            <Notification danger paddingTop small>
              {speVerifyEmailAddress.error}
            </Notification>
          )}
        </>
      )
    }

    return null
  }
}

export default EmailNotVerifiedBanner
